import React from 'react';
import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import LeagueRank from 'components/league/league_rank';
import NameWithIcons from 'components/user/name_with_icons';
import UserProfileImage from 'components/user/user_profile_image';

const TableRow = styled.div`
  display: flex;
  align-items: center;
  background-color: ${props => props.highlighted ? Theme.lightBlue : '#FFF'};
  border: 1px solid ${Theme.lightGray};
  border-radius: 5px;
  padding: 8px;
`;

const TableCell = styled.div`
  font-size: 14px;
  color: ${Theme.darkGray};
`;

const NameCell = styled(TableCell)`
  flex: 1;
  display: flex;
  gap: 5px;
`;

const XpCell = styled(TableCell)`
  text-align: right;
  width: fit-content;
  white-space: nowrap;
  font-weight: bold;
  color: #000;
`;

function LeagueUserRow({ userLeague, userId, promotionStatus }) {

  return (
    <TableRow
      highlighted={userId && userLeague.user.id === userId}
    >
      <LeagueRank
        rank={userLeague.rank}
        promotionStatus={promotionStatus}
      />
      <NameCell>
        <UserProfileImage
          clickToProfile
          showLanguageIcon={false}
          user={userLeague.user}
          width={40}
        />
        <NameWithIcons
          user={userLeague.user}
        />
      </NameCell>
      <XpCell>{userLeague.xp} XP</XpCell>
    </TableRow>
  );
}

export default LeagueUserRow;